import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unableToLoadData: {
		id: 'software-devops-report-common-error-retry.unable-to-load-data',
		defaultMessage: 'Unable to load data.',
		description: 'Display this message when loading data failed',
	},
	retry: {
		id: 'software-devops-report-common-error-retry.retry',
		defaultMessage: 'Retry',
		description: 'Label for a button that retries loading the data after an error',
	},
});
